import type { ServerColDef, ValueGetterParams } from '@cmg/data-grid';

import type { UnderwriterEmployeeFragment } from '../components/SalesCoverageGrid/graphql/__generated__';

export const valueGetter = ({ data }: ValueGetterParams<UnderwriterEmployeeFragment, boolean>) =>
  data?.userAccount?.isActive ?? false;

const activeUserAccountColDef: ServerColDef<UnderwriterEmployeeFragment, boolean> = {
  field: 'userAccount.isActive',
  headerName: 'Active User Account',
  valueGetter,
  type: ['boolean'],
  filter: false,
  sortable: false,
  minWidth: 180,
};

export default activeUserAccountColDef;
